"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Form = void 0;
var _react = _interopRequireDefault(require("react"));
var _socialLogin = require("./socialLogin");
var _useLogin2 = require("./useLogin");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Form = function Form(_ref) {
  var _ref$showOTPLoginOpti = _ref.showOTPLoginOption,
    showOTPLoginOption = _ref$showOTPLoginOpti === void 0 ? true : _ref$showOTPLoginOpti,
    _ref$primaryInputLabe = _ref.primaryInputLabel,
    primaryInputLabel = _ref$primaryInputLabe === void 0 ? "Email" : _ref$primaryInputLabe,
    _ref$showForgotPasswo = _ref.showForgotPassword,
    showForgotPassword = _ref$showForgotPasswo === void 0 ? true : _ref$showForgotPasswo,
    _ref$showSocialLogin = _ref.showSocialLogin,
    showSocialLogin = _ref$showSocialLogin === void 0 ? true : _ref$showSocialLogin,
    _ref$source = _ref.source,
    source = _ref$source === void 0 ? null : _ref$source,
    _ref$sendEvent = _ref.sendEvent,
    sendEvent = _ref$sendEvent === void 0 ? function (clickedOn) {} : _ref$sendEvent;
  var _useLogin = (0, _useLogin2.useLogin)({
      primaryInputLabel: primaryInputLabel,
      showSocialLogin: showSocialLogin,
      sendEvent: sendEvent,
      source: source
    }),
    handleLogin = _useLogin.handleLogin,
    otpSent = _useLogin.otpSent,
    setOTPSent = _useLogin.setOTPSent,
    setIntentId = _useLogin.setIntentId,
    email = _useLogin.email,
    setEmail = _useLogin.setEmail,
    error = _useLogin.error,
    setError = _useLogin.setError,
    otpLogin = _useLogin.otpLogin,
    password = _useLogin.password,
    setPassword = _useLogin.setPassword,
    timer = _useLogin.timer,
    sendOTP = _useLogin.sendOTP,
    otp = _useLogin.otp,
    setOTP = _useLogin.setOTP,
    showResendSuccessMsg = _useLogin.showResendSuccessMsg,
    setOTPLogin = _useLogin.setOTPLogin,
    socialLoginEnabled = _useLogin.socialLoginEnabled;
  return /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: handleLogin,
    autoComplete: "on",
    "data-sentry-component": "Form",
    "data-sentry-source-file": "form.tsx"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "login-form"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "login-box"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-field"
  }, /*#__PURE__*/_react["default"].createElement("label", null, primaryInputLabel, otpSent && otpLogin && /*#__PURE__*/_react["default"].createElement("a", {
    onClick: function onClick() {
      setOTPSent(false);
      setIntentId(null);
      sendEvent("Change ".concat(primaryInputLabel));
    }
  }, "Change ", primaryInputLabel)), /*#__PURE__*/_react["default"].createElement("input", {
    value: email,
    type: "email",
    placeholder: "Enter ".concat(primaryInputLabel),
    autoFocus: true,
    tabIndex: 1,
    disabled: otpSent,
    readOnly: otpSent,
    onChange: function onChange(_ref2) {
      var target = _ref2.target;
      error && setError(null);
      setEmail(target === null || target === void 0 ? void 0 : target.value);
    },
    autoComplete: "sl-user-login-email",
    name: "sl-user-login-email",
    "data-test-id": "user-login"
  }), otpLogin && otpSent && /*#__PURE__*/_react["default"].createElement("p", {
    className: "info"
  }, "We\u2019ve sent a verification code to the email above."), otpLogin && !otpSent && error && /*#__PURE__*/_react["default"].createElement("p", {
    className: "info error"
  }, error)), !otpLogin && /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-field"
  }, /*#__PURE__*/_react["default"].createElement("label", null, "Password", " ", showForgotPassword && /*#__PURE__*/_react["default"].createElement("a", {
    target: "_blank",
    onClick: function onClick() {
      return sendEvent("Forgot Password");
    },
    href: "/forgot_password",
    tabIndex: 4
  }, "Forgot password?")), /*#__PURE__*/_react["default"].createElement("input", {
    value: password,
    type: "password",
    placeholder: "Enter Password",
    tabIndex: 2,
    onChange: function onChange(_ref3) {
      var target = _ref3.target;
      error && setError(null);
      setPassword(target === null || target === void 0 ? void 0 : target.value);
    },
    autoComplete: "sl-user-login-password",
    name: "sl-user-login-password",
    "data-test-id": "user-password"
  }), error && /*#__PURE__*/_react["default"].createElement("p", {
    className: "info error"
  }, error)), otpLogin && otpSent && /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-field"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    "data-test-id": "enter-verification-code"
  }, "Enter Verification code", " ", /*#__PURE__*/_react["default"].createElement("a", {
    className: "".concat(timer ? "disabled otp-timer" : ""),
    onClick: function onClick() {
      return sendOTP();
    }
  }, "Resend code", timer ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, " ", "in ", /*#__PURE__*/_react["default"].createElement("strong", null, timer, "s")) : "")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "otp-text"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "text",
    className: "otp",
    maxLength: 6,
    autoComplete: "off",
    onChange: function onChange(_ref4) {
      var target = _ref4.target;
      error && setError(null);
      setOTP(target === null || target === void 0 ? void 0 : target.value);
    },
    autoFocus: true,
    value: otp,
    "data-test-id": "otp-input"
  }), /*#__PURE__*/_react["default"].createElement("input", {
    className: "autocomplete",
    type: "email",
    readOnly: true
  }), ["", "", "", "", "", ""].map(function (_char, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "otp-box"
    }, (otp === null || otp === void 0 ? void 0 : otp[index]) || "");
  })), error && /*#__PURE__*/_react["default"].createElement("p", {
    className: "info error"
  }, error), showResendSuccessMsg && /*#__PURE__*/_react["default"].createElement("p", {
    className: "info success"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "iconcust-iconCheck"
  }), " A new verification code has been sent.")), /*#__PURE__*/_react["default"].createElement("button", {
    "data-test-id": "login-submit-button",
    onClick: handleLogin,
    tabIndex: 3
  }, otpLogin ? "Submit" : "Login"), otpLogin && otpSent && /*#__PURE__*/_react["default"].createElement("p", {
    className: "email-info"
  }, "If you are not seeing the email, the email may have landed in your spam folder, or your account may be associated with a different email.")), showOTPLoginOption && /*#__PURE__*/_react["default"].createElement("div", {
    tabIndex: 5,
    className: "other-login-box",
    onClick: function onClick() {
      setOTPLogin(function (value) {
        return !value;
      });
      setError(null);
      sendEvent("Login via ".concat(otpLogin ? "Password" : "Verification Code"));
    },
    "data-test-id": "verification-code-hypertext"
  }, "Login via ", /*#__PURE__*/_react["default"].createElement("a", null, otpLogin ? "Password" : "Verification Code")), socialLoginEnabled && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "or-bar"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "or-bar-text"
  }, "or Login with")), /*#__PURE__*/_react["default"].createElement(_socialLogin.SocialLogin, null))));
};
exports.Form = Form;